import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "col-sm-4"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Lista", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Seleziona lista", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 1,
  class: "col-sm-4"
}
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Lavorato", -1)
const _hoisted_10 = {
  key: 2,
  class: "col-sm-4"
}
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Provvigioni cassaforte", -1)
const _hoisted_13 = {
  key: 3,
  class: "col-sm-6 mb-3"
}
const _hoisted_14 = { class: "box" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "boxTitle" }, "Dati di accesso", -1)
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Product level", -1)
const _hoisted_18 = { class: "col-sm-6 mb-3" }
const _hoisted_19 = { class: "box" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "boxTitle" }, "Dati fumatore", -1)
const _hoisted_21 = { class: "col-sm-6 mb-3" }
const _hoisted_22 = { class: "box mb-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "boxTitle" }, "Social networks", -1)
const _hoisted_24 = { class: "box mb-3" }
const _hoisted_25 = { class: "boxTitle" }
const _hoisted_26 = { class: "box" }
const _hoisted_27 = { class: "boxTitle" }
const _hoisted_28 = { class: "col-sm-6 mb-3" }
const _hoisted_29 = { class: "box mb-3" }
const _hoisted_30 = { class: "boxTitle" }
const _hoisted_31 = { class: "box mb-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "boxTitle" }, "Stati", -1)
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, "Stato", -1)
const _hoisted_35 = {
  key: 0,
  class: "form-control"
}
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", null, "Sub stato", -1)
const _hoisted_38 = {
  key: 0,
  class: "form-control"
}
const _hoisted_39 = { class: "box" }
const _hoisted_40 = { class: "boxTitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_auth_data = _resolveComponent("auth-data")!
  const _component_accordion = _resolveComponent("accordion")!
  const _component_dati_fumo = _resolveComponent("dati-fumo")!
  const _component_social_networks_data = _resolveComponent("social-networks-data")!
  const _component_commenti = _resolveComponent("commenti")!
  const _component_cronologia_scadenze = _resolveComponent("cronologia-scadenze")!
  const _component_note = _resolveComponent("note")!
  const _component_cronologia_stati = _resolveComponent("cronologia-stati")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.list) = $event))
            }, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lists, (item, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: item
                }, _toDisplayString(item), 9, _hoisted_6))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.user.list]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.lavorato) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.user.lavorato]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.provvigioniCassaforte) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.user.provvigioniCassaforte]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_accordion, null, {
              title: _withCtx(() => [
                _hoisted_15
              ]),
              default: _withCtx(() => [
                _createVNode(_component_auth_data, {
                  value: _ctx.user.authData
                }, null, 8, ["value"]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.productLevel) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.user.productLevel]
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_accordion, null, {
          title: _withCtx(() => [
            _hoisted_20
          ]),
          default: _withCtx(() => [
            _createVNode(_component_dati_fumo, {
              value: _ctx.user.calcoliFumo,
              readonly: _ctx.readonly
            }, null, 8, ["value", "readonly"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_accordion, null, {
          title: _withCtx(() => [
            _hoisted_23
          ]),
          default: _withCtx(() => [
            _createVNode(_component_social_networks_data, {
              value: _ctx.user.socialNetworksData,
              readonly: _ctx.readonly
            }, null, 8, ["value", "readonly"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_accordion, null, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, "Commenti (" + _toDisplayString(_ctx.user.comments.length) + ")", 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_commenti, {
              user: _ctx.user,
              readonly: _ctx.readonly
            }, null, 8, ["user", "readonly"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_accordion, null, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_27, "Cronologia scadenze (" + _toDisplayString(_ctx.user.scadenze.length) + ")", 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_cronologia_scadenze, { user: _ctx.user }, null, 8, ["user"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_accordion, null, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_30, "Note (" + _toDisplayString(_ctx.user.note.length) + ")", 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_note, {
              user: _ctx.user,
              readonly: _ctx.$store.state.isManager()
            }, null, 8, ["user", "readonly"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_component_accordion, null, {
          title: _withCtx(() => [
            _hoisted_32
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              (_ctx.readonly)
                ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.user.status), 1))
                : _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 1,
                    class: "form-control",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.status) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", { key: i }, _toDisplayString(item), 1))
                    }), 128))
                  ], 512)), [
                    [_vModelSelect, _ctx.user.status]
                  ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              (_ctx.readonly)
                ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.user.subStatus), 1))
                : _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 1,
                    class: "form-control",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.subStatus) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subStatuses, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", { key: i }, _toDisplayString(item), 1))
                    }), 128))
                  ], 512)), [
                    [_vModelSelect, _ctx.user.subStatus]
                  ])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createVNode(_component_accordion, null, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_40, "Cronologia stati (" + _toDisplayString(_ctx.user.cronologiaStati.length) + ")", 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_cronologia_stati, { user: _ctx.user }, null, 8, ["user"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}